module.exports = __webpack_public_path__ + "static/img/FQQY.a8496b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FQQY.png
// module id = A/mt
// module chunks = 18